import service from '@/store/services/profile-service';

const state = {
  me: null,
};

const mutations = {
  SET_RESOURCE: (state, me) => {
    state.me = me;
  }
};

const actions = {
  me({commit, dispatch}, params) {
    return service.get(params)
      .then((me) => {
        commit('SET_RESOURCE', me.list);
      });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((me) => {
        dispatch('me'); 
      });
  },

  updatePassword({commit, dispatch}, params) {
    return service.updatePassword(params)
      .then((me) => {
        dispatch('me'); 
      });
  },

  updateAgency({commit, dispatch}, params) {
    return service.updateAgency(params)
      .then((me) => {
        dispatch('me'); 
      });
  },
  updateAgencyToNull({commit, dispatch}, params) {
    return service.updateAgencyToNull(params)
      .then((me) => {
        dispatch('me'); 
      });
  },
};

const getters = {
  me: state => state.me
};

const profile = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default profile;
